module.exports = __webpack_public_path__ + "img/logo.7ac33469.png";